module.exports = __webpack_public_path__ + "img/p-12.360358b8.png";